import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page"
import RoomDatalist from "components/entities/accommodation/rooms/RoomDatalist";
import { AppRoutes } from "config/router";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const RoomDatalistPage = () => {
    const context = useAppContext();
    const pageActions: PageActionsType = [
        {
            icon: faPlus,
            name: 'add',
            title: 'button.add',
            link: AppRoutes.ACCOMMODATION_ROOM_FORM,
            hide: !context.userHasRole(Roles.ADMIN)
        }
    ]

    return (
        <Page wFull title="pages.accommodation.room.list" actions={pageActions}>
            <RoomDatalist name="pages-accommodation-room-list" />
        </Page>
    );
};

export default RoomDatalistPage;
